export const ZIPCODE_REGEX = /^\d{5}$/;
export const NON_DIGITS_REGEX = /[^\d]+/g;
export const PO_BOX_ADDRESS_REGEX =
  /\b(P(OST)?\.?\s*(O(FF(ICE)?)?)?\.?\s*B(IN\b|OX\b|\.?))/i;
export const NAME_REGEX = /^[a-zA-Z0-9&*#();\-@/." ]+$/;
export const PHONE_REGEX = /(\d.*){10}/;
export const COMPANY_NAME_REGEX = /^[a-zA-Z.*#().;@/&0-9' ]+$/;
export const ADDRESS_REGEX = /^[a-zA-Z\d\-_.,!@#$%^()+=? "'\\ :\s]+$/;
export const NUMBERS_REGEX_GLOBAL = /^[0-9]*$/g;
export const BASE64_ENCODED_REGEX =
  /^(?:[A-Za-z\d+/]{4})*(?:[A-Za-z\d+/]{3}=|[A-Za-z\d+/]{2}==)?$/;
export const NUMBERS_REGEX = /^[0-9]+$/;
export const CARD_HOLDER_NAME_REGEX = /^[a-zA-Z0-9&*#();\-@/." ]+$/;
export const BILLING_ADDRESS_REGEX = /^[A-Za-z0-9.&$\- ]*$/i;
export const CARD_NICKNAME_REGEX = /^[A-Za-z0-9_&\-#.'’ ]*$/;
export const NICKNAME_REGEX = /^[a-zA-Z0-9.#_&\- ]*$/;
export const CHECKING_ACCOUNT_ROUTING_REGEX = /^\d{9}$/;
export const KEYTAG_NUMBER_REGEX = /(\d{4})-?(\d{4})-?(\d{4})-?(\d{4})/;
export const CARD_LAST_4_DIGITS_REGEX = /^[0-9]{0,4}$/;
export const EXPIRY_REGEX = /^(0[1-9]|1[0-2])\/([0-9]{2})$/;
export const GIFT_CARD_PIN_REGEX = /^\d{4}$/;
export const NAME_ON_CARD_REGEX = /^[A-Za-z_\-. ]*$/;
export const NICKNAME_CARD_REGEX = /^[a-zA-Z0-9.#_&\- ]*$/;
export const SPACE_CHECKER_REGEX = /\s/g;
export const EXPIRATION_DATE = /^(0[1-9]|1[0-2]|[1-9])([0-9]{2})$/;
